import React from "react";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error("[ErrorBoundary]", error, info?.componentStack);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
        window.location.href = "/feed";
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6" data-testid="error-boundary">
                    <div className="max-w-md w-full glass rounded-2xl p-6 text-center">
                        <AlertTriangle className="w-10 h-10 text-[#FF5722] mx-auto mb-3" />
                        <h2 className="font-display font-black text-2xl mb-2">Oups, un souci est survenu</h2>
                        <p className="text-white/70 font-body text-sm mb-3">
                            La page n'a pas pu s'afficher correctement. Rechargez la page ou revenez au feed.
                        </p>
                        <p className="text-[10px] text-white/40 font-mono break-all mb-4 bg-black/40 rounded p-2 text-left">
                            {String(this.state.error?.message || this.state.error || "Erreur inconnue")}
                        </p>
                        <div className="flex gap-2 justify-center">
                            <button
                                onClick={() => window.location.reload()}
                                data-testid="error-reload-btn"
                                className="h-11 px-5 rounded-full bg-white/10 border border-white/20 font-body font-bold text-sm"
                            >
                                Recharger
                            </button>
                            <button
                                onClick={this.handleReset}
                                data-testid="error-home-btn"
                                className="orange-btn h-11 px-5 rounded-full font-body font-bold text-sm"
                            >
                                Retour au feed
                            </button>
                        </div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
